"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snlConfiguration = exports.snl = void 0;
const commonMargins_1 = require("./commonMargins");
const modifyConfig_1 = require("../modifyConfig");
const variety_1 = require("./variety");
const SNL_OVERRIDES = {
    slug: {
        marginLeft: 0,
        width: 55,
        lineHeight: 1,
        blockTopMargin: 1,
        alignment: 'left',
    },
    bracket: {
        marginLeft: 0,
        width: 27,
        uppercase: true,
        bold: true,
        color: 'black',
    },
    parenthetical: {
        marginLeft: 0,
        width: 27,
        blockTopMargin: 1,
        uppercase: true,
    },
    dialogue: {
        marginLeft: 2,
        width: 33,
        lineHeight: 2,
        blockTopMargin: 0,
    },
    character: {
        marginLeft: 15,
        width: 25,
        uppercase: true,
    },
    general: {
        marginLeft: 0,
        width: 60,
        color: 'black',
    },
    new_act: {
        marginLeft: 0,
        width: 20,
        blockTopMargin: 0,
    },
};
exports.snl = (0, modifyConfig_1.modifyConfig)(variety_1.variety, SNL_OVERRIDES);
const numbering = {
    slug: 'auto',
    sceneHeading: 'auto',
    bracket: 'none',
    dialogue: 'none',
    dual_dialogue: 'none',
};
exports.snlConfiguration = {
    blocks: exports.snl,
    margins: {
        topRight: commonMargins_1.SNL_SLENE_NAME_BY_NUMBER,
        // note that we always include the timestamp but it gets set '' unless
        // we pass in a value
        topLeft: commonMargins_1.TIMESTAMP,
    },
    numbering,
};
